import { render, staticRenderFns } from "./form-address.vue?vue&type=template&id=02399646&scoped=true"
import script from "./form-address.vue?vue&type=script&lang=js"
export * from "./form-address.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02399646",
  null
  
)

export default component.exports